import { API_URL } from "./config";
import { IS_BOT } from "./botDetection";
import { BISKOUI_SETTINGS, SESSION_ID } from "./utils";

export function initialize() {
  let engagementSent = false;
  function sendEngagement() {
    if (engagementSent || IS_BOT) return;
  
    engagementSent = true;
    fetch(
      `${API_URL}/v1/cookie-banners/${BISKOUI_SETTINGS.clientId}/engagement`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sessionId: SESSION_ID,
        }),
      }
    );
  }
  
  let visitorEngaged = false;
  window.addEventListener("scroll", function () {
    sendEngagement();
    visitorEngaged = true;
  });
  window.addEventListener("click", function () {
    sendEngagement();
    visitorEngaged = true;
  });
  
  let engagementTimer: number | undefined = undefined;
  
  // We only start the counter if visibilityState is "visible". If "hidden", it means the page was reloaded
  // but not actually seen by the visitor.
  if (document.visibilityState == "visible") {
    engagementTimer = window.setTimeout(function () {
      sendEngagement();
      visitorEngaged = true;
    }, 13000);
  }
  
  // According to mozilla docs:
  // This event fires with a visibilityState of hidden when a user navigates to a
  // new page, switches tabs, closes the tab, minimizes or closes the browser, or,
  // on mobile, switches from the browser to a different app. Transitioning to
  // hidden is the last event that's reliably observable by the page, so developers
  // should treat it as the likely end of the user's session (for example, for
  // sending analytics data).
  document.addEventListener("visibilitychange", function logData() {
    if (document.visibilityState === "visible") {
      if (!visitorEngaged) {
        engagementTimer = window.setTimeout(function () {
          sendEngagement();
          visitorEngaged = true;
        }, 13000);
      }
    } else if (document.visibilityState === "hidden") {
      clearTimeout(engagementTimer);
    }
  });

}
